import { useLang } from "@/i18n";

export const Expertise = () => {
  const h = useLang().t.home;
  return (
    <section data-testid="expertise-section" className="max-w-7xl mx-auto px-6 sm:px-12 pb-20 sm:pb-24">
      <div className="grid lg:grid-cols-12 gap-8 lg:gap-20 border-t border-[#1A2522]/15 pt-12 sm:pt-14">
        <div className="lg:col-span-4">
          <span className="divider"></span>
          <h2 data-testid="expertise-title" className="mt-6 font-serif font-medium text-2xl sm:text-[30px] text-[#1A2522] leading-[1.2] tracking-tight">{h.expertiseTitle}</h2>
        </div>
        <div className="lg:col-span-8 max-w-3xl space-y-5" data-testid="expertise-text">
          {h.expertise.map((p, i) => (
            <p key={i} className="text-[14px] sm:text-[15px] text-[#495854] leading-[1.8] font-light">{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
};
